import axios from 'axios';
import config from '@/config';

const baseUrl = `${config.ctx.iffApi}/jxxf/pg`;

export const pgReportService = {
  page: params => axios.get(`${baseUrl}/report`, { params }),
  detail: bgId => axios.get(`${baseUrl}/report/${bgId}`),
  prepare: xmId => axios.get(`${baseUrl}/report/project/${xmId}/prepare`),
  preview: xmId => axios.post(`${baseUrl}/report/project/${xmId}/preview`),
  generate: xmId => axios.post(`${baseUrl}/report/project/${xmId}/generate`),
  download: (bgId, fileType) => axios.get(`${baseUrl}/report/${bgId}/file/${fileType}`, {
    responseType: 'blob'
  }),
  reevaluate: (xmId, data) => axios.post(`${baseUrl}/project/${xmId}/reevaluate`, data)
};
